import { Input, Image, Text, View, Tab, Prompt } from 'components';
import Base, { Config } from 'components/saleTool/Base';
import cx from 'classnames';
import React from 'react';
import styles from './index.module.scss';
import { history } from 'modules/navigator';
import { user } from 'modules/saleTool/store';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Loading, Toast } from 'components/Modal';
import copy from 'copy-to-clipboard';

// interface Order {
//   create_time: string;
//   status: number;
//   name: string;
//   phone: string;
//   is_pay: number;
//   is_install: number;
//   address: string;
//   id: number;
//   city?: string;
//   province?: string;
//   order_goods?: any;
//   other_price?: number;
//   pay_type: number;
//   sell_info: any;
// }

interface good {
  id: number;
  goods_type: number;
  goods_num: number;
  sell_price: number;
  true_price?: number;
}

interface Creater {
  name: string;
  phone: string;
  status: number;
}

interface State {
  order: any;
  goods: good[];
  creater: Creater;
  statusArr: any;
  loading: boolean;
  userType: number;
  showModal: boolean;
  edsnName: string;
  edsnCode: string;
  applyId?: number;
  applySta?: number;
}

let lock = false;

export default class OrderDetail extends Base<any> {
  public config: Config = {
    navigationBarTitleText: '订单详情'
  };

  public state: State = {
    order:{},
    goods:[],
    creater:{
      name: '',
      phone: '',
      status: 0,
    },
    statusArr: ['待确认','待审核','待发货','已发货'],
    loading: false,
    userType: 0,
    showModal:false,
    edsnName: '',
    edsnCode: ''
  };

  public async didMount() {
    await this.getUserInfo()
    this.getDetail()
    
    // console.log(this.props.location.state.id)
  }

  private copyFun = (str) => {
    if(copy(str)){
      toast.info("复制成功！",{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
    }else{
      toast.error("复制失败！请手动复制",{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
    }
  }

  private getUserInfo = async() => {
    const res = await this.apiClient.base.userListInfo()
    console.log(res);
    if(res && res.status == 10000){
      this.setState({
        userType: res.body.type
        // userType: 2
      })
    }
    
  }

  private link = url => {
    history.push(url);
  }

  private getDetail = async() => {
    const res = await this.apiClient.base.orderListInfo({
      id:this.props.location.state.id
    })
    if(res.status == 10000){
      this.setState({
        order:res.body,
        creater:res.body.sell_info,
        goods:res.body.order_goods
      })
    }
    console.log(res);
  }

  private showLoading = () => {
    this.setState({
      loading:true
    })
  }
  private hideLoading = () => {
    this.setState({
      loading:false
    })
  }

  private valueChange = (name,e) => {
    // console.log(name,e.target.value);
    this.setState({[name]:  e.target.value})
  }

  private promptConfirm = () => {
    const { edsnName, edsnCode, applyId, applySta } = this.state
    // console.log(edsnName, edsnCode);
    if(edsnName.replace(/\s+/g,"") == '' || edsnCode.replace(/\s+/g,"") == ''){
      toast.error("请填写完整",{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      return;
    }
    let edsn = edsnName+"/"+edsnCode
    // console.log(applyId,applySta,edsn)
    this.applySubmit(applyId,applySta,edsn)
    this.promptCancel()
  }

  private promptCancel = () => {
    this.setState({
      showModal: false,
      edsnName: "",
      edsnCode: ""
    })
  }

  private apply = async(id,sta) => {
    let edsn = '';
    if(sta == 3) {
      this.setState({
        showModal: true,
        applyId: id,
        applySta: sta,
      })
      return;
      // const result=await prompt("请填写快递单号");
      // if(!result || result == " "){
      //   toast.error("需填写快递单号",{
      //     position: toast.POSITION.TOP_RIGHT,
      //     autoClose: 1500,
      //     closeButton: false,
      //   })
      //   return;
      // }
      // edsn = result
    }else {
      const result = await confirm("是否确定提交");
      if(!result){return;}
    }

    this.applySubmit(id,sta)
  }

  private applySubmit = async(id,sta,edsn='') => {
    // console.log(id,sta,edsn);return;
    this.showLoading()
    let res = await this.apiClient.base.orderEdit({
      id,
      status:sta,
      edsn
    })
    if(res.status == 10000){
      toast.info("提交成功！",{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      this.getDetail()
    }else{
      toast.error(res.msg,{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
    }
    this.hideLoading()
  }

  private delete = async(id) => {
    const result = await confirm("是否确定删除");
    if(!result){return;}
    this.showLoading()
    let res = await this.apiClient.base.orderDelete({
      id
    })
    if(res.status == 10000){
      toast.info("删除成功！",{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      history.push("/saleTool/main")
      
    }else{
      toast.error(res.msg,{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
    }
    this.hideLoading()
  }

  private edit = (id) => {
    history.push('/saleTool/orderAdd',{id})
  }


  public render() {
    const { order, creater, goods, statusArr, loading, userType, showModal, edsnName, edsnCode } = this.state;

    return (
      <View className={styles.container}>
        <Loading isOpen={loading} />
        <ToastContainer className={styles.ToastContainer}/>
        <Prompt isOpen={showModal} className={styles.modal} onCancel={this.promptCancel} onConfirm={this.promptConfirm}>
          <View className={styles.modalBox}>
            <View className={styles.modalLis}>
              <View className={styles.modalTit}>输入快递公司名称</View>
              <View className={styles.modalMain}>
                <Input
                  value={edsnName}
                  name="edsnName"
                  className={styles.input}
                  placeholder="请填写"
                  valueChange={this.valueChange}
                />
              </View>
            </View>
            <View className={styles.modalLis}>
              <View className={styles.modalTit}>输入快递单号</View>
              <View className={styles.modalMain}>
                <Input
                  value={edsnCode}
                  name="edsnCode"
                  className={styles.input}
                  placeholder="请填写"
                  valueChange={this.valueChange}
                />
              </View>
            </View>
          </View>
        </Prompt>
        <View className={styles.sec}>
          <View className={styles.head}>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>订单号：</Text>
              <Text className={styles.lis_m}>{order.id}</Text>
              <Text className={cx(styles.lis_r,styles.rr)}>{statusArr[order.status]}</Text>
            </View>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>创建者：</Text>
              <Text className={styles.lis_m}>{creater.name}</Text>
            </View>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>创建时间：</Text>
              <Text className={styles.lis_m}>{order.create_time}</Text>
            </View>
            {order.edsn && order.edsn != '' && (
              <View className={styles.lis}>
                <Text className={styles.lis_l}>快递单号：</Text>
                <Text className={styles.lis_m}>{order.edsn}</Text>
                <Text className={styles.lis_r} onClick={this.copyFun.bind(null,order.edsn)}>复制</Text>
              </View>
            )}
            
          </View>
        </View>
        <View className={styles.sec}>
          <Text className={styles.title}>客户信息</Text>
          <View className={styles.list}>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>客户姓名</Text>
              <Text className={styles.lis_m}>{order.name}</Text>
              <Text className={styles.lis_r} onClick={this.copyFun.bind(null,order.name)}>复制</Text>
            </View>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>客户电话</Text>
              <Text className={styles.lis_m}>{order.phone}</Text>
              <Text className={styles.lis_r} onClick={this.copyFun.bind(null,order.phone)}>复制</Text>
            </View>
            {order.province && (
              <View className={styles.lis}>
                <Text className={styles.lis_l}>省份</Text>
                <Text className={styles.lis_m}>{order.province}</Text>
                <Text className={styles.lis_r} onClick={this.copyFun.bind(null,order.province)}>复制</Text>
              </View>
            )}
            {order.city && (
              <View className={styles.lis}>
                <Text className={styles.lis_l}>城市</Text>
                <Text className={styles.lis_m}>{order.city}</Text>
                <Text className={styles.lis_r} onClick={this.copyFun.bind(null,order.city)}>复制</Text>
              </View>
            )}
            <View className={styles.lis}>
              <Text className={styles.lis_l}>收货地址</Text>
              <Text className={styles.lis_m}>{order.address}</Text>
              <Text className={styles.lis_r} onClick={this.copyFun.bind(null,order.address)}>复制</Text>
            </View>
            
          </View>
        </View>
        <View className={styles.sec}>
          <Text className={styles.title}>商品信息</Text>
          {goods.map((option , index) => {
            return(
              <View key={index}>
                {option.goods_num > 0 && (
                  <View className={styles.list}>
                    <Text className={styles.tinyTitle}>{option.goods_type == 1 ? "标准版": "增强版"}</Text>
                    <View className={styles.lis}>
                      <Text className={styles.lis_l}>商品数量</Text>
                      <Text className={styles.lis_m}>{option.goods_num}</Text>
                    </View>
                    <View className={styles.lis}>
                      <Text className={styles.lis_l}>出售价格</Text>
                      <Text className={styles.lis_m}>{option.sell_price}</Text>
                    </View>
                    <View className={styles.lis}>
                      <Text className={styles.lis_l}>商品原价</Text>
                      <Text className={styles.lis_m}>{option.true_price}</Text>
                    </View>
                  </View>
                )}
              </View>
            )
          })}
          
        </View>
        <View className={styles.sec}>
          <Text className={styles.title}>其他信息</Text>
          <View className={styles.list}>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>是否到账</Text>
              <Text className={styles.lis_m}>{order.is_pay == 1?"已到账":"未到账"}</Text>
            </View>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>到账渠道</Text>
              <Text className={styles.lis_m}>
                {order.pay_type == 1?"微信转账":(order.pay_type == 2?"微店下单":"到付")}
              </Text>
            </View>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>上门安装</Text>
              <Text className={styles.lis_m}>{order.is_install == 1?"上门安装":"不需要上门"}</Text>
            </View>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>其他费用</Text>
              <Text className={styles.lis_m}>{order.other_price}</Text>
            </View>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>备注信息</Text>
              <Text className={styles.lis_m}>{order.remark}</Text>
            </View>
            
            
          </View>
        </View>

        {userType == 1 && (
          <View className={styles.bottom}>
            <View className={styles.cancel} onClick={this.delete.bind(this,order.id)}>删除订单</View>
            <View className={styles.edit} onClick={this.edit.bind(this,order.id)}>修改订单</View>
            {order.status == 0 && (<View className={styles.pass} onClick={this.apply.bind(this,order.id,1)}>提交审核</View>)}
            {order.status == 1 && (<View className={styles.pass} onClick={this.apply.bind(this,order.id,2)}>通过审核</View>)}
            {order.status == 2 && (<View className={styles.pass} onClick={this.apply.bind(this,order.id,3)}>快递发货</View>)}
          </View>
        )}
        {userType == 2 && order.status == 0 && (
          <View className={styles.bottom}>
            <View className={styles.cancel} onClick={this.delete.bind(this,order.id)}>删除订单</View>
            <View className={styles.edit} onClick={this.edit.bind(this,order.id)}>修改订单</View>
            <View className={styles.pass} onClick={this.apply.bind(this,order.id,1)}>提交审核</View>
          </View>
        )}
        {userType == 3 && (
          <View className={styles.bottom}>
            <View className={styles.pass} onClick={this.apply.bind(this,order.id,3)}>快递发货</View>
          </View>
        )}
        

      </View>
    );
  }
}
